import { useMemo } from 'react';
import { UserRole } from '@repo/shared-types';
import type { NavSchemaContext } from '@repo/shared-config';
import { useProperties } from './queries/useProperties';
import { useAppStore } from '../store';

/**
 * Org-scoped flags for {@link getNavItemsForRole} filtering (cap table, SFR-only portfolio).
 */
export function useOrgNavFeatures(): NavSchemaContext['orgFeatures'] {
  const { userRole } = useAppStore();
  const { data: properties = [] } = useProperties();

  return useMemo(() => {
    const sfrOnlyPortfolio =
      properties.length > 0 && properties.every((p) => p.type === 'Single Family');

    // PM external workspace: cap-table nav visible unless org explicitly lacks ownership modeling.
    // Owner/SMO: default true (ownership surfaces are role-native).
    const hasCapTable =
      userRole === UserRole.OWNER ||
      userRole === UserRole.PROPERTY_MANAGER ||
      userRole === UserRole.ADMIN;

    return { hasCapTable, sfrOnlyPortfolio };
  }, [properties, userRole]);
}
